/* XAN Final v7 — stable motion layer. Homepage restored; page header scope corrected. */
(() => {
  const body = document.body;
  if (!body) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header state: preserve the stable V5 behavior. */
  let scrollFrame = 0;
  const syncHeaderState = () => {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => {
      body.classList.toggle('xan-scrolled', window.scrollY > 18);
      scrollFrame = 0;
    });
  };
  syncHeaderState();
  window.addEventListener('scroll', syncHeaderState, { passive: true });

  /* Optical pointer highlight only on genuine floating glass surfaces. */
  const glassSelector = [
    '.button:not(.button-unstyled)',
    '.button-secondary:not(.button-unstyled):not(.skip-to-content-link)',
    '.add-to-cart-button',
    '.cart__checkout-button',
    '.quick-add__button',
    '.dialog-modal',
    '.dialog-drawer',
    '.xan-contact-card'
  ].join(',');

  let pointerFrame = 0;
  let pointerEvent = null;
  const paintPointer = () => {
    pointerFrame = 0;
    const event = pointerEvent;
    if (!event || event.pointerType === 'touch') return;
    const element = event.target.closest?.(glassSelector);
    if (!element) return;
    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
    const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
    element.style.setProperty('--xan-glow-x', `${x}%`);
    element.style.setProperty('--xan-glow-y', `${y}%`);
  };
  document.addEventListener('pointermove', (event) => {
    pointerEvent = event;
    if (!pointerFrame) pointerFrame = requestAnimationFrame(paintPointer);
  }, { passive: true });

  /* Safe reveal system: opacity + translate only. Product images are never filtered. */
  const revealObserver = (reduceMotion || !('IntersectionObserver' in window)) ? null : new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-xan-visible');
      revealObserver.unobserve(entry.target);
    });
  }, { root: null, rootMargin: '0px 0px -7% 0px', threshold: 0.06 });

  const registerMotion = (root = document) => {
    const revealNodes = [...root.querySelectorAll?.('.xan-reveal') || []];
    const cards = [...root.querySelectorAll?.('.template-collection #MainContent .product-card, .template-search #MainContent .product-card') || []];
    cards.forEach((card) => card.classList.add('xan-card-reveal'));

    const nodes = [...revealNodes, ...cards];
    if (!nodes.length) return;

    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    nodes.forEach((node, index) => {
      if (node.dataset.xanMotionInit === 'true') return;
      node.dataset.xanMotionInit = 'true';
      node.style.setProperty('--xan-delay', `${Math.min((index % 4) * 45, 135)}ms`);

      const rect = node.getBoundingClientRect();
      const alreadyVisible = rect.top < viewportH * 0.96 && rect.bottom > 0;
      if (reduceMotion || !revealObserver || alreadyVisible) {
        node.classList.add('is-xan-visible');
      } else {
        revealObserver?.observe(node);
      }
    });
  };

  registerMotion(document);
  requestAnimationFrame(() => body.classList.add('xan-motion-ready'));

  /* Shopify can replace sections after filtering/infinite-scroll/theme-editor edits. */
  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('.xan-reveal, .product-card') || node.querySelector?.('.xan-reveal, .product-card')) {
          registerMotion(node.matches?.('.xan-reveal, .product-card') ? node.parentElement || node : node);
        }
      }
    }
  });
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => registerMotion(event.target));
})();
